module.exports = __webpack_public_path__ + "img/hard-disc.d981084e.svg";